import { graphene } from 'graphql/tags'

export const orderEvents = graphene`#graphql
  fragment OrderEvents on BrandAccount {
    orderEvents {
      edges {
        node {
          id
          name
          code
        }
      }
    }
  }
`

export const salesReps = graphene`#graphql
  fragment SalesReps on BrandAccount {
    salesRepresentatives {
      edges {
        node {
          id
          name
          code
        }
      }
    }
  }
`

export const orders = graphene`#graphql
  fragment Orders on BrandAccount {
    orders {
      edges {
        node {
          id
          retailerName
          shippingAddress {
            id
            code
          }
          status
          latestExports {
            edges {
              node {
                id
                name
                status
                exportDescription
                created
              }
            }
          }
          referenceNumber
          collections {
            edges {
              node {
                id
                name
              }
            }
          }
          webOrderLookupId
          modified
          deliveryComplete
          eventName
          eventCode
          salesRepresentative {
            id
            name
          }
          type {
            edges {
              node {
                id
                name
              }
            }
          }
          webOrderLookupId
        }
      }
    }
  }
`
